/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SecurityAccessFeaturesEnum } from './SecurityAccessFeaturesEnum';
import {
    SecurityAccessFeaturesEnumFromJSON,
    SecurityAccessFeaturesEnumFromJSONTyped,
    SecurityAccessFeaturesEnumToJSON,
} from './SecurityAccessFeaturesEnum';
import type { UserInformationViewModel } from './UserInformationViewModel';
import {
    UserInformationViewModelFromJSON,
    UserInformationViewModelFromJSONTyped,
    UserInformationViewModelToJSON,
} from './UserInformationViewModel';

/**
 * 
 * @export
 * @interface AccessResponseViewModel
 */
export interface AccessResponseViewModel {
    /**
     * 
     * @type {string}
     * @memberof AccessResponseViewModel
     */
    companyName: string;
    /**
     * 
     * @type {string}
     * @memberof AccessResponseViewModel
     */
    brand: string;
    /**
     * 
     * @type {Array<SecurityAccessFeaturesEnum>}
     * @memberof AccessResponseViewModel
     */
    features: Array<SecurityAccessFeaturesEnum>;
    /**
     * 
     * @type {UserInformationViewModel}
     * @memberof AccessResponseViewModel
     */
    userInformation: UserInformationViewModel;
}

/**
 * Check if a given object implements the AccessResponseViewModel interface.
 */
export function instanceOfAccessResponseViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "companyName" in value;
    isInstance = isInstance && "brand" in value;
    isInstance = isInstance && "features" in value;
    isInstance = isInstance && "userInformation" in value;

    return isInstance;
}

export function AccessResponseViewModelFromJSON(json: any): AccessResponseViewModel {
    return AccessResponseViewModelFromJSONTyped(json, false);
}

export function AccessResponseViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessResponseViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyName': json['CompanyName'],
        'brand': json['Brand'],
        'features': ((json['Features'] as Array<any>).map(SecurityAccessFeaturesEnumFromJSON)),
        'userInformation': UserInformationViewModelFromJSON(json['UserInformation']),
    };
}

export function AccessResponseViewModelToJSON(value?: AccessResponseViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'CompanyName': value.companyName,
        'Brand': value.brand,
        'Features': ((value.features as Array<any>).map(SecurityAccessFeaturesEnumToJSON)),
        'UserInformation': UserInformationViewModelToJSON(value.userInformation),
    };
}

